export default "__VITE_ASSET__C1q2gjni__"